import { type Timezone } from './timezoneTypes';
import { type userType } from '@constants';

export interface SessionDetail {
  sessionId: string;
  sdrName: string;
  sdrId: string;
  organizationId: string;
  organizationName: string;
}

export interface CurrentUser {
  userId: string;
  userName: string;
  sessionDetail?: SessionDetail;
  type: UserType[];
  isAdmin: boolean;
  isSuperAdmin: boolean;
  isTendrilUser: boolean;
  isSdr: boolean;
  isAgent: boolean;
  sdrId?: string;
  sdrName?: string;
  organizationId: string;
  email: string;
  timezone: Timezone;
  avatar?: string;
}

export interface SafeUserDto {
  id: string;
  name: string;
  email: string;
  userType: UserType[];
  profilePicture?: string | null;
  organizationId: string;
  sdrId?: string | null;
  timezone: Timezone;
}

export interface User {
  _id: string;
  id: string;
  name: string;
  email: string;
  userType: UserType[];
  organizationId: string;
  organizationName?: string | null;
  sdrId?: string | null;
  timezone?: Timezone | null;
  profilePicture: string | null;
  deletedAt?: Date | null;
}

export interface CreateUserDto {
  _id: string;
  id: string;
  name: string;
  email: string;
  userType:  Array<{ type: userType }>;
  organizationId: string;
  organizationName?: string;
  sdrId?: string | null;
  timezone?: Timezone;
  profilePicture: string;
  deletedAt?: Date | null;
  password?: string;
}

export const USER_TYPE_LIST = ['admin', 'sdr', 'agent'] as const;

export type UserType = typeof USER_TYPE_LIST[number];

export class UploadImageDto {
  file!: File;
}


